<template>
    <div id="landing">
      <v-img :src="bannerLogo" id="banner-logo" />
      <v-img :src="sunsetImg" id="banner-img">
        <v-row justify="center" align="center">
          <AuthCardEmail
            v-if="!isLogged"
            :newUser="false"
            onSuccessPath="/catalog"
            :colorFrontMain="$vuetify.theme.themes.light.primary" 
            :colorFrontLight="$vuetify.theme.themes.light.primary_light"
            :colorBackMain="$vuetify.theme.themes.light.secondary"
            :colorBackLight="$vuetify.theme.themes.light.secondary_light"
            class="signup-panel" />
          <v-card v-else width="500" height="300" elevation="10">
            <v-card-text class="body-1"> 
              Hello, {{displayName}}
            </v-card-text>
            <v-row justify="center">
              <div class="title" style="margin-top: 30px;"> 
                Red Sky Designs Events
              </div>
              <span v-for='(element, index) in news' :key='index' style="width: 90%">
                <br><font class="font-italic">{{element.date}}</font><v-icon color="primary"> mdi-chevron-right </v-icon>{{element.text}}
                <v-divider style="margin: 0px; padding: 0px;" />
              </span>
            </v-row>
          </v-card>
        </v-row>
        <v-row justify="center" align="center" id="image-caption">
          <div class="title white--text text-xs-center">
            Contact lori@redskydesigns.com for access or questions.
          </div>
        </v-row>
      </v-img>
       
    </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'

import { mask } from 'vue-the-mask'

// import { firebase } from '@/utils/firebase'

export default {
  name: 'landing',
  directives: {
    mask,
  },
  data () {
      return {
        bannerLogo: require('@/assets/banner-logo.png'),
        sunsetImg: require('@/assets/landing/red_sunset.svg'),
        news: null
      }
  },
  mounted() {
    this.getNews()
  },
  computed: {
    ...mapGetters({
      debug: 'getDebug',
      loading: 'getLoading',
      isLogged: 'getIsLogged',
      displayName: 'getDisplayName'
    }),
  },
  methods: {
    handleSignOut: function () {
      this.$store.dispatch('userSignOut')
    },
    getNews: async function () {
      this.news = await this.$store.dispatch('getNews', 'landing')
    }
  }
}
</script>

<style scoped>

#landing {
  width: 100%;
  align-content: center;
  padding-left: auto;
  padding-right: auto;
  position: relative;
  padding: 40px;
}

#banner-logo {
  width: 90%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
  margin-top: 0px;
}

#banner-img {
  padding-top: 200px;
  padding-bottom: auto;
  border-style: double;
  border-width: 2px;
}


#signup-panel {
  width: 40%;
  height: auto;

  margin-top: auto;
  margin-bottom: auto;

}

#image-caption {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-right: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}


</style>



